import { Component, OnInit, ChangeDetectionStrategy, Inject, Input } from '@angular/core';
import { FormControl, FormGroup, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FormHelpers } from '@asamco/utils';
import { L10N_LOCALE, L10nLocale, L10nTranslatePipe } from 'angular-l10n';
import { BehaviorSubject } from 'rxjs';
import { Link } from '../../interfaces/link.interface';
import { LogSettings } from '../../interfaces/log-settings.interface';
import { LinkService } from '../../services/link.service';
import { AsValidatorDirective } from '../../../../../../base/src/lib/as-validator/as-validator.directive';
import { DxTextBoxModule, DxSwitchModule } from 'devextreme-angular';
import { NgIf, AsyncPipe } from '@angular/common';

@Component({
    selector: 'al-link-log-settings',
    templateUrl: './link-log-settings.component.html',
    styleUrls: ['./link-log-settings.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [
        NgIf,
        FormsModule,
        ReactiveFormsModule,
        DxTextBoxModule,
        AsValidatorDirective,
        DxSwitchModule,
        AsyncPipe,
        L10nTranslatePipe,
    ],
})
export class LinkLogSettingsComponent implements OnInit {
	/** The log settings object */
	@Input()
	link: Link;

	/** Form group for the log form */
	@Input()
	formGroup: FormGroup;

	public formInitialized$: BehaviorSubject<boolean> =  new BehaviorSubject<boolean>(false);

	constructor(@Inject(L10N_LOCALE) public locale: L10nLocale, private linkService: LinkService) {}

	ngOnInit(): void {
		this.initializeForm();
	}

	private initializeForm() {
		this.linkService.get(this.link.id).subscribe(retrievedLink => {
			this.formGroup.addControl('mailLogs', new FormControl(retrievedLink.mailLogs));

			this.formGroup.addControl('mailAddress', new FormControl( {value: retrievedLink.mailAddress, disabled: !retrievedLink.mailLogs }));

			this.formInitialized$.next(true);
		})
	}
}
